module.exports = __webpack_public_path__ + "img/system-uicons_duplicate.dc04bfce.svg";